import {Component, Input, Output, EventEmitter, HostBinding} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-button-alt',
    imports: [CommonModule],
    templateUrl: './button-alt.component.html',
    styleUrls: ['./button-alt.component.scss']
})
export class ButtonAltComponent {
  @Input() borderColor: string = 'var(--teal-500)';
  @Input() buttonColor: string = 'var(--teal-500)';
  @Input() textColor: string = 'var(--grey-neutral-50)';
  @Input() text: string = '-';
  @Input() additionalClass: string = '';
  @Input() leadingIcon?: string;
  @Input() leadingIconClass?: string;
  @Input() trailingIcon?: string;
  @Input() trailingIconSize: string = '24px';
  @Input() leadingIconSize: string = '24px';
  @Output() onClickCallback: EventEmitter<Event> = new EventEmitter<Event>();
  @Input() isFullWidth: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() minWidth: string = 'auto';
  @Input() textTransform: string = 'none';
  @Input() fontWeight: string = '400';
  @Input() borderRadiusTopLeft?: string = '6px';
  @Input() borderRadiusBottomLeft?: string = '6px';
  @Input() buttonHeight: string = '52px';
  @Input() fontSize: string = '16px';
  @Input() hoverColor: string = '';
  @Input() isSelected: boolean = false;

  isHovered: boolean = false;

  onClick(event: Event): void {
    if (!this.isDisabled) {
      this.onClickCallback.emit(event);
    }
  }

  @HostBinding('class.full-width') get fullWidthClass(): boolean {
    return this.isFullWidth;
  }

}
